import { UserInfo, Ticket } from './user';

export { UserInfo, Ticket };

export class CurrentUser {
    constructor() { 
        this.User = new UserInfo();
    }
    public Token: string;
    public User: UserInfo;
}


// WEBPACK FOOTER //
// ./src/entities/currentUser.ts